import React from 'react'

import { BadgeColor, MUIBadge } from 'components/common/MUIBadge'
import { VatValidationStatus } from 'dataQueries/invoicingAddresses.query'
import { useTranslation } from 'react-i18next'
import { Country } from 'constants/country'

/** Countries where VAT validation badges should not be displayed */
const COUNTRIES_WITHOUT_VAT_BADGE = new Set([Country.DE, Country.CH])

interface Props {
  status?: VatValidationStatus
  vatNumber?: string
  country?: Country
  size?: 'xs' | 'sm'
}

const STATUS_CONFIG: Partial<Record<VatValidationStatus, { color: BadgeColor; labelKey: string }>> = {
  [VatValidationStatus.VALID]: { color: 'green', labelKey: 'invoicing_address_form:vat_status.VALID' },
  [VatValidationStatus.INVALID]: { color: 'coral', labelKey: 'invoicing_address_form:vat_status.INVALID' },
}

export const VatValidationStatusBadge: React.FC<Props> = React.memo(({
  status,
  vatNumber,
  country,
  size = 'sm',
}) => {
  const { t } = useTranslation(['invoicing_address_form'])

  if (!vatNumber || !status) return null

  if (country && COUNTRIES_WITHOUT_VAT_BADGE.has(country)) return null

  const config = STATUS_CONFIG[status]

  if (!config) return null

  return (
    <MUIBadge
      label={t(config.labelKey)}
      size={size}
      color={config.color}
      role="status"
      aria-label={t(config.labelKey)}
    />
  )
})

VatValidationStatusBadge.displayName = 'VatValidationStatusBadge'
